
import SFXS from '../../../assets/audios/audios'

interface buttonProp {
  name: string
  content: string | JSX.Element
  longPressEnabled?: boolean
  SFX?: any
}
export const buttons: buttonProp[] = [
  { name: '1/2', content: '1/2', SFX: SFXS.divideSFX },
  { name: '2x', content: '2X', SFX: SFXS.multiplySFX },
  { name: '5x', content: '5X', SFX: SFXS.multiplySFX },
  { name: '10x', content: '10X', SFX: SFXS.multiplySFX },
]
